import { useEffect, useRef } from "react";

type AutoLogoutProps = {
  children?: React.ReactNode;
  timeoutMinutes?: number;
};

const AutoLogout = ({ children, timeoutMinutes = 10 }: AutoLogoutProps) => {
  const timeoutId = useRef<number | null>(null);
  const initialized = useRef(false);

  const userIsLogged = () => {
    return !!localStorage.getItem("token");
  };

  const isProtectedFlow = () => {
    const hash = window.location.hash.toLowerCase();

    return (
      hash.includes("pago") ||
      hash.includes("suscripcion") ||
      hash.includes("checkout") ||
      hash.includes("success")
    );
  };

  const resetTimer = () => {
    if (!userIsLogged()) return;

    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }

    timeoutId.current = window.setTimeout(() => {
      if (isProtectedFlow()) {
        resetTimer();
        return;
      }


      localStorage.removeItem("token");
      window.dispatchEvent(new Event("tokenChanged"));

      window.location.hash = "#/";
    }, timeoutMinutes * 60 * 1000);
  };

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    if (!userIsLogged()) return;

    const events = ["mousemove", "keydown", "scroll", "touchstart"];

    const handleActivity = () => resetTimer();

    events.forEach((event) =>
      window.addEventListener(event, handleActivity)
    );

    const handleVisibility = () => {
      if (document.visibilityState === "visible") {
        resetTimer();
      }
    };

    document.addEventListener("visibilitychange", handleVisibility);

    const handleTokenChange = () => {
      if (userIsLogged()) {
        resetTimer();
      } else {
        if (timeoutId.current) clearTimeout(timeoutId.current);
      }
    };

    window.addEventListener("tokenChanged", handleTokenChange);

    resetTimer();

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, handleActivity)
      );

      document.removeEventListener("visibilitychange", handleVisibility);
      window.removeEventListener("tokenChanged", handleTokenChange);

      if (timeoutId.current) clearTimeout(timeoutId.current);
    };
  }, [timeoutMinutes]);

  return <>{children}</>;
};

export default AutoLogout;